import {createContext, ReactNode, useCallback, useContext, useState} from "react";

export type PageData = Record<string, unknown>

type PageContextType = {
    pageData: PageData
    setPageData: (data: PageData) => void
    resetPageData: () => void
}

const PageContext = createContext<PageContextType | undefined>(undefined)

export const usePageData = (): PageContextType => {
    const ctx = useContext(PageContext)
    if (!ctx) {
        console.error('usePageData must be used within a PageProvider')
    }
    return ctx
}

export const PageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [pageData, setRawPageData] = useState<PageData>({})

    const setPageData = useCallback(
        (data: PageData) => setRawPageData(prev => ({ ...prev, ...data })),
        []
    )

    const resetPageData = useCallback(() => setRawPageData({}), [])

    return (
        <PageContext.Provider value={{ pageData, setPageData, resetPageData }}>
            {children}
        </PageContext.Provider>
    )
}